<template>
  <!--  <MainHeader title="Product Overviews"/>-->
  <div class="flex space-x-2 justify-center">
    <h2 class=" text-4xl font-semibold mb-8 leading-tight text-gray-800">
      Just Food
      <span class="inline-block py-1.5 px-2.5 leading-none text-center whitespace-nowrap align-baseline font-bold bg-green-600 text-white rounded">Recipe</span>
    </h2>
  </div>


  <div class="bg-white m-auto p-12 content-wrapper block lg:flex lg:align max-w-7xl">

    <img class="object-cover mx-auto lg:m-0 " :src="result ? result.recipeDetail.image : 'https://upload.wikimedia.org/wikipedia/commons/b/b1/Loading_icon.gif?20151024034921'" alt="">

    <div v-if="loading" class=" mt-8 lg:ml-8 lg:mt-0 ">
      <h2 class="text-4xl font-semibold text-[1f2c38] sm:pr-12">Loading Recipe...</h2>
    </div>

    <div v-if="error" class=" mt-8 lg:ml-8 lg:mt-0 ">
      <h2 class="text-4xl font-semibold text-[1f2c38] sm:pr-12">Something go wrong...</h2>
    </div>

    <div v-else class="w-full mt-8 lg:ml-8 lg:mt-0 ">



      <h2 class="text-4xl font-semibold text-[1f2c38] sm:pr-12">{{result.recipeDetail.name}}</h2>

      <h3 class="mt-6 mb-2 text-[1f2c38] font-bold ">CreatedDate: {{convertDate(result.recipeDetail.createdAt)}}</h3>

      <h3 class="mt-6 mb-2 text-2xl text-[1f2c38] font-semibold">📄 Instruction</h3>
      <p>{{ result.recipeDetail.instruction }}</p>

      <h3 class="mt-6 mb-2 text-2xl text-[1f2c38]  font-semibold">🥕 Ingredients</h3>

      <div v-if="result.recipeDetail.ingredients.length > 0" class="mb-8 flex flex-col">
        <div class="overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div class="py-2 inline-block min-w-full sm:px-6 lg:px-8">
            <div class="overflow-hidden">
              <table class="min-w-full">
                <thead class="bg-white border-b">
                <tr>
                  <th scope="col" class="text-sm font-medium text-gray-900 px-6 py-4 text-left">
                    #
                  </th>
                  <th scope="col" class="text-sm font-medium text-gray-900 px-6 py-4 text-left">
                    Ingredient
                  </th>
                  <th scope="col" class="text-sm font-medium text-gray-900 px-6 py-4 text-left">
                    Quantity
                  </th>
                  <th scope="col" class="text-sm font-medium text-gray-900 px-6 py-4 text-left">
                    QuantityType
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(ingredient,index) in result.recipeDetail.ingredients"
                    :key="ingredient.id"
                    class="bg-white border-b transition duration-300 ease-in-out hover:bg-green-100">

                  <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{{index + 1}}</td>
                  <td class="text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap">
                    {{ingredient.name}}
                  </td>
                  <td class="text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap">
                    {{ingredient.quantity}}

                  </td>
                  <td class="text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap">
                    {{ingredient.quantityType}}
                  </td>
                </tr>

                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <p v-else class="mb-8">{{ selectItem.ingredient }}</p>

      <IngredientForm/>

    </div>

  </div>

</template>

<script>
import {useQuery} from "@vue/apollo-composable";
import { useRoute } from 'vue-router'
import gql from "graphql-tag";
import moment from "moment";
import IngredientForm from "@/components/IngredientForm";

const GET_RECIPE_DETAIL = gql`
query RecipeDetail($recipeDetailId: ID!) {
  recipeDetail(id: $recipeDetailId) {
    id
    name
    instruction
    image
    createdAt
    updatedAt
    ingredients {
      name
      quantity
      quantityType
    }
  }
}
`;


// const { mutate:AddIngredient, loading, error } = addingResult

export default {
  name: "RecipeView",
  components: {IngredientForm},
  methods:{
    convertDate(date)
    {
      return moment(parseInt(date)).format("MMM Do YYYY")
    },
  },
  props:{
    selectItem:{
      type: Object,
      required: true,
      default () {
        return {
          title: "Title",
          createdAt:"12/12/12",
          ingredient: "No Ingredients Add yet!",
          description: "Description",
        }
      }
    }
  },
  setup()
  {
    const route = useRoute()

    const { result,loading,error,onResult } = useQuery(GET_RECIPE_DETAIL,{recipeDetailId: route.params.id}, {pollInterval: 250})

    onResult(()=>
        console.log(result)
    )
    return {
      result,
      loading,
      error,
    }
  },
}
</script>

<style scoped>
.content-wrapper{
}
img{
  max-width:500px;
  aspect-ratio: 16/9;
  height: 100%;
  width: 100%;
}
</style>